var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLikeImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 124,
    viewBox: "0 0 192 124",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "9831gnwkha",
    d: "M0 0h191.58v102.538H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u32ph0sj6c",
    d: "M0 0h102.539v102.538H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "wc89mpsz6e",
    d: "M0 0h96.555v49.43H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 21.334)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "3p42kcbfmb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#9831gnwkha"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M140.31 0c-23.784 0-43.78 16.198-49.572 38.163L0 64.584l94.24 9.189c8.337 17.034 25.83 28.765 46.071 28.765 28.315 0 51.27-22.953 51.27-51.269C191.58 22.954 168.625 0 140.31 0",
    fill: "#000",
    opacity: 0.218,
    mask: "url(#3p42kcbfmb)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(89.041)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "12wkmhfvod",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u32ph0sj6c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M102.539 51.268c0 28.316-22.954 51.27-51.27 51.27C22.954 102.538 0 79.584 0 51.268 0 22.953 22.954 0 51.269 0c28.316 0 51.27 22.953 51.27 51.268",
    fill: "#578BFF",
    mask: "url(#12wkmhfvod)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M163.566 47.01V47h.604a3.997 3.997 0 1 0 0-7.992h-15.573l2.895-5.97s1.28-2.506 1.28-6.68c0-4.174-1.879-8.45-5.099-8.45a3.539 3.539 0 0 0-3.538 3.536v3.635s.454 1.724-1.77 3.95c-2.228 2.228-10.696 10.57-10.696 16.111v23.032a2.802 2.802 0 0 0 2.802 2.804h26.067a3.995 3.995 0 0 0 0-7.99h1.584a3.998 3.998 0 0 0 0-7.994h1.278a3.992 3.992 0 0 0 .166-7.983M126.044 45.3h-12.446c-1.547 0-2.471 1.256-2.801 2.803l-4.814 24.087c-.251 1.547 1.256 2.801 2.803 2.801h17.258a2.8 2.8 0 0 0 2.8-2.8V48.102a2.801 2.801 0 0 0-2.8-2.803",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 36.488)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "xkn3ps0nsf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wc89mpsz6e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#578BFF",
    mask: "url(#xkn3ps0nsf)",
    d: "M96.555 36.987 0 49.43 93.92 0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeImg);
export default __webpack_public_path__ + "static/media/like_img.696a79a2344183a99aaeb4fbb7c1e41c.svg";
export { ForwardRef as ReactComponent };